<template>
    <div class="refundList">
        <Head :headInfo='headInfo' @onClickLeft='onBack' />
        <div class="navTab">
            <v-switcher v-if="tabNav.length>0" :headers="tabNav" align="start" :headerHeight="44" :default-index="tabIndex" @change="handleTabSwitch" />
        </div>
        <div class="content">
            <van-pull-refresh v-model="finish.isLoading" :head-height='20' @refresh="onRefresh">
            <van-list v-model="finish.loading" :finished="finish.finished" :finished-text="finish.finishText" :immediate-check="false" @load="onLoad">
                <div class="list" v-for="(item, index) in goodList" :key="index">
                    <div class="name"><ShopName :name="item.shopName" /></div>
                    <div class="refundCode">{{ item.orderType === 1 ? '退货单编号' : '退款单编号' }}：{{ item.number }}</div>
                    <div class="list_good"  @click="onDetail(item.id, item.orderType)" v-for="(it, idx) in item.productDetails" :key="idx" v-show="idx < 2">
                        <GoodTemplate :goods='it' :goodLength="item.productDetails.length" :goodIndex="0" />
                    </div>
                    <div class="totalNumber">共{{ item.totalQuantity }}件 合计：<span><sub>¥</sub> {{ item.totalAmount | NumFormat }}</span></div>
                    <div class="totalBtn" v-if="item.refundStatus === 1 || item.returnStatus === 10" @click="getRevoke(item.id, item.orderType)"><span>撤销申请</span></div>
                </div>
            </van-list>
            </van-pull-refresh>
            <Empty v-if="!goodList.length" />
        </div>
    </div>
</template>
<script>
import Head from '../../common/head'
import ShopName from './components/shopName'
import GoodTemplate from './components/goodTemplate'
import Empty from '../common/Empty'
import { getRenturens, getReturnsRevoke } from '../api/order'
import { clearCache, newCache } from '@/utils/index'
import { Toast } from 'vant'

const tabNav = new Map([
    [0, { label: '全部', value: 0 }],
    [1, { label: '待审核', value: 1 }],
    [2, { label: '退货中', value: 2 }],
    [3, { label: '退款中', value: 3 }],
    [4, { label: '已退款', value: 4 }],
    [5, { label: '换货中', value: 5 }],
    [6, { label: '已换货', value: 7 }],
    [7, { label: '申请失败', value: 8 }]
])
export default {
    name: 'refundList',
    components: {
        Head,
        Empty,
        ShopName,
        GoodTemplate
    },
    data () {
        return {
            headInfo: {
                title: '退款/售后'
            },
            userInfo: JSON.parse(localStorage.getItem('userInfo')),
            // tabNav: ['全部', '待审核', '退货中', '退款中', '已退款', '换货中', '已退货', '已换货', '申请失败'],
            tabNav: [],
            tabIndex: parseInt(this.$route.query.tabIndex) || 0,
            goodList: [],
            finish: {
                loading: false,
                isLoading: false,
                finished: false,
                finishText: '数据已加载完毕',
                pageNumber: 1,
                pageSize: 10,
                totalNumber: 0
            }
        }
    },
    beforeRouteEnter (to, from, next) {
        newCache('refundList')
        next()
    },
    beforeRouteLeave (to, from, next) {
        if (to.name !== 'refundDetail') {
            clearCache('refundList')
        }
        console.log(window.scrollY)
        this.$route.meta.savedPosition = window.scrollY
        next()
    },
    mounted () {
        for (let values of tabNav.values()) {
            this.tabNav.push(values.label)
        }
    },
    methods: {
        onBack () {
            this.$router.replace({ path: '/b2b/order/index' })
        },
        onDetail (id, orderType) {
            this.$router.push({ path: '/b2b/refundOrder/detail', query: { tabIndex: this.tabIndex, id: id, orderType: orderType } })
        },
        onLoad () {
            console.log(this.finish.pageNumber)
            this.finish.pageNumber += 1
            this.initData()
        },
        onRefresh () {
            setTimeout(() => {
                this.goodList = []
                this.finish.pageNumber = 1
                this.finish.pageSize = 10
                this.finish.finished = true
                this.initData()
            }, 1000)
        },
        handleTabSwitch (type) {
            this.goodList = []
            this.tabIndex = tabNav.get(type).value || 0
            this.finish.pageNumber = 1
            this.finish.pageSize = 10
            this.finish.finished = true
            this.initData()
        },
        async getRevoke (id, orderType) {
            await getReturnsRevoke({ id: id, orderType: orderType })
            this.handleTabSwitch(this.$route.query.tabIndex)
        },
        async initData () {
            const { data } = await getRenturens({
                pageSize: this.finish.pageSize,
                pageNumber: this.finish.pageNumber,
                status: this.tabIndex,
                memberCode: this.userInfo.companyCode
            })
            this.goodList = this.goodList.concat(data.records)
            this.totalNumber = data.total
            this.finish.loading = false
            this.finish.isLoading = false
            this.finish.finished = false
            if (this.goodList.length >= data.total) {
                this.finish.finished = true
                this.finish.loading = true
                this.finish.finishText = '数据已加载完毕'
            }
            if (data.total < this.finish.pageSize) {
                this.finish.finishText = ''
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.refundList {
    font-size: 28px;
    background: #f5f5f5;
    .navTab {
        position: fixed;
        left: 0;
        right: 0;
        background: #ffffff;
        color: #666666;
        z-index: 99;
    }
    .content {
        padding: 80px 16px 0;
        .list {
            margin-top: 20px;
            background-color: #ffffff;
            border-radius: 8px;
            padding: 32px 0 0;
            .name {
                padding: 0 16px;
            }
            &_good {
                padding-left: 16px;
                margin-top: 32px;
            }
            .refundCode {
                padding: 16px;
                font-size: 24px;
                color: #333333;
                border-bottom: 2px solid #ededf0;
            }
        }
    }
    .totalNumber {
        margin-left: 16px;
        border-top: 2px solid #ededf0;
        font-size: 30px;
        color: #000;
        padding: 24px 16px;
        text-align: right;
        span {
            color: #ff7a45;
        }
        sub {
            font-size: 20px;
        }
    }
    .totalBtn {
        font-size: 28px;
        color: #ff7a45;
        text-align: right;
        padding: 24px 16px 32px;
        border-top: 2px solid #ededf0;
        span {
            display: inline-block;
            height: 64px;
            line-height: 64px;
            padding: 0 48px;
            border: 2px solid #ff7a45;
            border-radius: 64px;
        }
    }
}
/deep/ .v-switcher-header-item {
    padding: 0 36px;
    font-size: 28px;
    &.is-active {
        color: #ff7a45;
    }
}
</style>